// @flow
import React from 'react'
import styled from 'styled-components'

import { myTheme, themedTextColor } from '../../../styles'
import { addRef, addHash } from './endnotes.service'

const { fontSize } = myTheme

const StyledBacklink = styled.a`
  font-size: ${fontSize.six};
  color: ${themedTextColor};
  text-decoration: none;
`
const IconPath = styled.path`
  fill: ${themedTextColor};
`

type Props = {
  to: string,
  color?: string,
}

const EndnoteBacklink = ({ to, color }: Props) => (
  <StyledBacklink href={addHash(addRef(to))}>
    <span style={{ width: fontSize.six }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="11"
      >
        <IconPath
          fill={color}
          fillRule="evenodd"
          d="M.54 7.219l3.374-3.375V6.64H9.79a2.41 2.41 0 0 0
             1.777-.735c.487-.49.73-1.08.73-1.773
             0-.693-.243-1.284-.73-1.774a2.413
             2.413 0 0 0-1.777-.734h-.187V.469h.187c1.016 0 1.88.358 2.594
             1.074a3.536 3.536 0 0 1 1.07 2.59c0 1.01-.357 1.874-1.07
             2.59-.714.716-1.578 1.074-2.594 1.074H3.914v2.797L.54 7.219z"
        />
      </svg>
    </span>
  </StyledBacklink>
)
EndnoteBacklink.defaultProps = {
  color: myTheme.color.white,
}

export default EndnoteBacklink



// WEBPACK FOOTER //
// ./src/components/typography/endnotes/endnote-backlink.js